/**
 * ErrorBanner — displays a dismissible error message.
 */

import React from "react";
import { useTranslation } from "react-i18next";

interface ErrorBannerProps {
  message: string;
  errorCode?: string;
  onDismiss?: () => void;
}

export const ErrorBanner: React.FC<ErrorBannerProps> = ({
  message,
  errorCode,
  onDismiss,
}) => {
  const { t } = useTranslation();

  return (
    <div className="error-banner" role="alert">
      <div className="error-banner__body">
        {errorCode && (
          <span className="error-banner__code">{errorCode}</span>
        )}
        <span className="error-banner__message">{message}</span>
      </div>
      {onDismiss && (
        <button
          className="error-banner__dismiss"
          onClick={onDismiss}
          aria-label={t("actions.dismissError")}
        >
          ✕
        </button>
      )}
    </div>
  );
};
